var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMic)?_c('div',{staticClass:"mic",class:_vm.isRecording ? 'mic_on' : '',on:{"click":function($event){return _vm.toggleRecording(_vm.isRecording)}}},[_c('img',{attrs:{"src":require("../../assets/mic.svg")}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60e8037b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SpeechRecognition.vue
// module id = btYt
// module chunks = 1